import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import useAuthStore from "../../store/authStore";
import useUIStore from "../../store/uiStore";

export default function Layout() {
  const { isAuthenticated, initializeAuth , isInitialized } = useAuthStore();
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed);
  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-[#f4f6f8]">
      <Header />
      <div className="flex pt-16">
        <Sidebar goToTop={goToTop} />
        <main className={`flex-1 transition-all duration-300 min-h-[calc(100vh-4rem)] overflow-x-auto ${sidebarCollapsed ? "lg:ml-16" : "lg:ml-56"}`}>
          <div className="p-4 sm:p-6 overflow-x-visible">
            <Outlet />
          </div>
        </main>
      </div>
      <button
        onClick={goToTop}
        className="fixed bottom-6 right-6 lg:bottom-8 lg:right-8 bg-primary-600 hover:bg-primary-700 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-40 group"
        aria-label="Scroll to top"
      >
        <svg
          className="w-5 h-5 lg:w-6 lg:h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    </div>
  );
}
